import React from 'react'
import { useState } from 'react'
import styles from './style.module.scss'
import TaskDrawerHeader from '../TaskDrawerHeader'
import TodoList from 'pages/todo/components/TodoList'
import { FilterType, SortType } from 'pages/todo/modules/TodoFilter'
import { modalTodoDetails } from 'pages/todo/components/TodoDetails/modalHelpers'
import settings from 'popups/Settings'

interface TaskDrawerProps {
  headerHeight: number
  focusDate: Date
  onClose: () => void
}
const TaskDrawer: React.FC<TaskDrawerProps> = ({ headerHeight, focusDate, onClose }) => {
  const [currentSortOption, setCurrentSortOption] = useState(SortType.Created)
  const [sortAscending, setSortAscending] = useState(true)
  const locale = settings.getLocale()

  // Todo 선택 핸들러 - todo 페이지와 동일하게 Editor 모달 실행
  const onTodoSelect = (todo: any) => {
    console.log('TaskDrawer onTodoSelect:', todo)
    // todo Editor 를 dialog 로 실행한다.
    modalTodoDetails(todo)
  }

  // 정렬 방향 토글 핸들러
  const onSortDirectionToggle = () => {
    const newSortAscending = !sortAscending
    setSortAscending(newSortAscending)
  }

  // 정렬 옵션 선택 핸들러
  const onSortOptionSelect = (sortOption: any) => {
    console.log('TaskDrawer onSortOptionSelect:', sortOption)
    setCurrentSortOption(sortOption)
  }

  return (
    <div className={styles.taskDrawer}>
      <TaskDrawerHeader headerHeight={headerHeight} onClose={onClose} />
      <TodoList
        selectedTodo={null}
        initSearchText={null}
        currentFilter={FilterType.FocusDate}
        sortOption={currentSortOption}
        sortAscending={sortAscending}
        focusDate={focusDate}
        locale={locale}
        onTodoSelect={onTodoSelect}
        onSortDirectionToggle={onSortDirectionToggle}
        onSortChange={onSortOptionSelect}
      />
    </div>
  )
}

export default TaskDrawer
